import axios, { AxiosResponse } from 'axios';

export interface IOsobyData {
    datumnacteni: string;
    osoby: IEsmOsoba[];
}

export enum EEsmStav {
    ESMDOPL = 'ESMDOPL', // osoba načtená z ESM, která nemá zadané všechny povinné údaje
    ESMOK = 'ESMOK', // osoba načtená z ESM, která má vyplněné všechny povinné údaje
    ESMODEB = 'ESMODEB', // osoba načtená z ESM, odebraná uživatelem
    RUCNE = 'RUCNE' // osoba zadaná uživatelem
}

export interface IEsmOsoba {
    jmeno: string;
    prijmeni: string;
    datumnarozeni?: string;
    ulice?: string;
    mesto?: string;
    psc?: string;
    stat?: string;
    stavesm: EEsmStav;
    datumnar?: string; // interne hodnoty po naformatovani
    adma?: string; // interne hodnoty po naformatovani
    mema?: string; // interne hodnoty po naformatovani
    pscm?: string; // interne hodnoty po naformatovani
    kost?: string; // interne hodnoty po naformatovani
}

const C4osoby = (ico: string) => {
    return axios({
        method: 'GET',
        url: '/ESM/Osoby',
        params: {
            ico: ico
        }
    }).then((resp: AxiosResponse<IOsobyData>) => resp.data);
};

export default C4osoby;
